import styled from 'styled-components';
import { getMargins, SYS_SIZE_FIXED_50 } from '@oneaudi/unified-web-alpha-common';
export const StyledDivider = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  width: ${(props) => props.$orientation === 'vertical' ? SYS_SIZE_FIXED_50 : '100%'};
  height: ${(props) => props.$orientation === 'vertical' ? '100%' : SYS_SIZE_FIXED_50};
  background-color: ${(props) => props.theme.sem.color.ui.foreground.divider.default};
`;
//# sourceMappingURL=index.styles.js.map